import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.821 8.8s-.147-1.094-.631-1.588c-.6-.642-1.283-.642-1.599-.684-2.24-.168-5.586-.168-5.586-.168h-.01s-3.366 0-5.586.168c-.316.042-1.01.053-1.61.684-.473.494-.63 1.588-.63 1.588S4 10.095 4 11.4v1.21c0 1.293.168 2.577.168 2.577s.148 1.094.631 1.588c.6.642 1.41.62 1.768.684 1.283.126 5.438.168 5.438.168s3.366 0 5.586-.168c.316-.042 1-.042 1.599-.684.473-.494.631-1.588.631-1.588S20 13.902 20 12.608v-1.21c0-1.293-.168-2.598-.168-2.598zm-9.478 5.27V9.58l4.324 2.251z"
    }, null, -1)
  ])))
}
export default { render: render }